import { render, staticRenderFns } from "./kxjl-steps.vue?vue&type=template&id=39f0b397&scoped=true"
import script from "./kxjl-steps.vue?vue&type=script&lang=js"
export * from "./kxjl-steps.vue?vue&type=script&lang=js"
import style0 from "./kxjl-steps.vue?vue&type=style&index=0&id=39f0b397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f0b397",
  null
  
)

export default component.exports